import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom'
import { apiLogout, ui } from './shared'
import type { AdminUser } from './shared'

const sections: { path: string; label: string }[] = [
  { path: 'sections',   label: 'Visibilità sezioni' },
  { path: 'hero',       label: 'Hero' },
  { path: 'identita',   label: 'Identità' },
  { path: 'singoli',    label: 'Singoli' },
  { path: 'videos',     label: 'Video' },
  { path: 'gallery',    label: 'Gallery' },
  { path: 'repertorio', label: 'Repertorio' },
  { path: 'date_live',  label: 'Date live' },
  { path: 'contatti',   label: 'Contatti' },
  { path: 'media',      label: 'Media' },
  { path: 'site',       label: 'SEO / Meta' },
]

export function Dashboard({ user, onLoggedOut }: { user: AdminUser; onLoggedOut: () => void }) {
  const nav = useNavigate()

  async function logout() {
    await apiLogout()
    onLoggedOut()
    nav('/admin', { replace: true })
  }

  return (
    <div className="ax-admin-shell" style={{ ...ui.shell, display: 'grid', gridTemplateColumns: '240px 1fr', minHeight: '100vh' }}>
      <aside className="ax-admin-aside" style={{
        background: 'var(--ink)', color: 'var(--fg-inverse)',
        padding: '28px 20px', position: 'sticky', top: 0, height: '100vh',
        overflowY: 'auto',
      }}>
        <Link to="/" style={{
          display: 'block',
          fontFamily: 'var(--font-display)', fontWeight: 500,
          textTransform: 'uppercase', letterSpacing: '0.04em',
          fontSize: 22, color: 'var(--fg-inverse)', textDecoration: 'none',
          marginBottom: 4,
        }}>Ancreus</Link>
        <div style={{ fontFamily: 'var(--font-body)', fontSize: 10, letterSpacing: '0.24em', textTransform: 'uppercase', color: 'var(--fg-inverse-muted)' }}>
          admin · {user.username}
        </div>

        <nav style={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: 32 }}>
          {sections.map((s) => (
            <NavLink key={s.path} to={`/admin/${s.path}`} end style={({ isActive }) => ({
              fontFamily: 'var(--font-body)', fontSize: 13,
              padding: '10px 12px', textDecoration: 'none',
              color: isActive ? 'var(--fg-inverse)' : 'var(--fg-inverse-muted)',
              background: isActive ? 'rgba(232,228,220,0.06)' : 'transparent',
              borderLeft: isActive ? '2px solid var(--accent)' : '2px solid transparent',
            })}>{s.label}</NavLink>
          ))}
        </nav>

        <button type="button" onClick={logout} style={{
          ...ui.btnGhost, color: 'var(--fg-inverse)', borderColor: 'var(--line-inverse)',
          marginTop: 32, width: '100%',
        }}>Esci</button>
      </aside>

      <main className="ax-admin-main" style={{ padding: '36px 40px', maxWidth: 1100 }}>
        <Outlet />
      </main>
    </div>
  )
}

export function DashboardHome() {
  return (
    <div>
      <h1 style={ui.sectionTitle}>Benvenuto</h1>
      <p style={{ fontSize: 14, color: 'var(--fg-muted)', maxWidth: 600 }}>
        Scegli una sezione dal menù per modificare i contenuti del sito. Ogni modifica viene pubblicata immediatamente — non c'è staging.
      </p>
    </div>
  )
}
